import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Layout from './components/Layout';
import Home from './pages/Home';
import Members from './pages/Members';
import Videos from './pages/Videos';
import Merch from './pages/Merch';
import Contact from './pages/Contact';
import { AppProvider } from './context/AppContext';
import './styles.css';

const STORAGE_KEYS = {
  language: 'salty_language',
  theme: 'salty_theme',
};

const getStoredValue = (key, fallback) => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  try {
    return window.localStorage.getItem(key) || fallback;
  } catch (error) {
    console.warn(`Unable to read ${key} from localStorage`, error);
    return fallback;
  }
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const section = document.querySelector(hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname, hash]);

  return null;
};

const AppRoutes = () => (
  <>
    <ScrollManager />
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/members" element={<Members />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/merch" element={<Merch />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  </>
);

function App() {
  const [language, setLanguage] = useState(() => getStoredValue(STORAGE_KEYS.language, 'fr'));
  const [theme, setTheme] = useState(() => getStoredValue(STORAGE_KEYS.theme, 'dark'));

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEYS.theme, theme);
    }
  }, [theme]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEYS.language, language);
    }
  }, [language]);

  const toggleLanguage = () => setLanguage((prev) => (prev === 'en' ? 'fr' : 'en'));
  const toggleTheme = () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <AppProvider value={{ language, toggleLanguage, theme, toggleTheme }}>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
}

export default App;
